import { createContext, useContext } from 'react';

import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';

export type EnterpriseBrowseCollectionsContextType = {
  browseCollectionsLoading: boolean;
  browseCollections?: DiscoveryCollection[];
};

const EnterpriseBrowseCollectionsContext = createContext<EnterpriseBrowseCollectionsContextType>({
  browseCollectionsLoading: false,
  browseCollections: undefined,
});

export const useEnterpriseBrowseCollections = () => useContext(EnterpriseBrowseCollectionsContext);

export default EnterpriseBrowseCollectionsContext;
